<nav>
    <div class="nav-info">
        <a routerLink="/" class="main-link" (click)="closeMenus($event)">
            <pc-full-logo></pc-full-logo>
        </a>
        <div class="business-info">
            <a href="tel:+17178981723">(717) 898-1723</a>
            <a href="mailto:info&#64;pchaines.com">info&#64;pchaines.com</a>
        </div>
    </div>
    <!-- Desktop Nav -->
    <div class="nav-links">
        <a routerLink="/about-us" (click)="closeMenus($event)">About Us</a>
        <div class="dropdown" [ngClass]="{ 'active': toggledDropdown }">
            <div class="trigger" (click)="toggleDropdown($event)">
                <p>Services</p>
                <span class="arrow"></span>
            </div>
            <div class="dropdown-menu">
                <a routerLink="/services" (click)="closeMenus($event)">Overview</a>
                <a routerLink="/services/division-5" (click)="closeMenus($event)">Division 5</a>
                <a routerLink="/services/division-6" (click)="closeMenus($event)">Division 6</a>
                <a routerLink="/services/division-7" (click)="closeMenus($event)">Division 7</a>
                <a routerLink="/services/division-9" (click)="closeMenus($event)">Division 9</a>
                <a routerLink="/services/division-10" (click)="closeMenus($event)">Division 10</a>
            </div>
        </div>
        <a routerLink="/projects" (click)="closeMenus($event)">Project Gallery</a>
        <a class="button" routerLink="/contact-us" (click)="closeMenus($event)">
            Contact Us
        </a>
    </div>
    <a class="button mobile-menu-toggle" (click)="toggleMobileMenu($event)" [ngClass]="{ 'active': toggledMobileMenu }">
        <p>Menu</p>
        <div class="hamburger">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </a>
</nav>

<!-- Mobile Nav Dropdown -->
<div class="mobile-navigation" [ngClass]="{ 'active': toggledMobileMenu }">
    <div class="nav-links">
        <a routerLink="/about-us" (click)="closeMenus($event)">About Us</a>
        <div class="dropdown" [ngClass]="{ 'active': toggledDropdown }">
            <div class="trigger" (click)="toggleDropdown($event)">
                <p>Services</p>
                <span class="arrow"></span>
            </div>
            <div class="dropdown-menu">
                <a routerLink="/services" (click)="closeMenus($event)">Overview</a>
                <a routerLink="/services/division-5" (click)="closeMenus($event)">Division 5</a>
                <a routerLink="/services/division-6" (click)="closeMenus($event)">Division 6</a>
                <a routerLink="/services/division-7" (click)="closeMenus($event)">Division 7</a>
                <a routerLink="/services/division-9" (click)="closeMenus($event)">Division 9</a>
                <a routerLink="/services/division-10" (click)="closeMenus($event)">Division 10</a>
            </div>
        </div>
        <a routerLink="/projects" (click)="closeMenus($event)">Project Gallery</a>

        <a class="button" routerLink="/contact-us" (click)="closeMenus($event)">
            Contact Us
        </a>
    </div>
    <div class="business-info">
        <div class="business-section">
            <p><strong>PC Haines Inc.</strong> <br>132 West Broad Street <br>Salunga, PA 17538</p>
        </div>
        <div class="business-section">
            <p>Monday-Friday: 6:30AM-3:30PM <br>Saturday & Sunday: Closed</p>
        </div>

        <div class="business-section contact">
            <a href="tel:+17178981723">(717) 898-1723</a>
            <a href="mailto:info&#64;pchaines.com">info&#64;pchaines.com</a>

            <div class="social-links">
                <a href="https://www.facebook.com/pchainesinc/" target="_blank">
                    <pc-facebook-logo></pc-facebook-logo>
                </a>
                <a href="https://www.linkedin.com/company/pc-haines-inc-wall-ceiling-contractor/" target="_blank">
                    <pc-linkedin-logo></pc-linkedin-logo>
                </a>
            </div>
        </div>
    </div>
</div>

<!-- Mask -->
<div class="nav-mask" (click)="closeMenus($event)" [ngClass]="{ 'active': toggledDropdown || toggledMobileMenu }"></div>